import Vue from 'vue'
import App from './App.vue'
import VuePageTransition from 'vue-page-transition'
import router from './router'
import store from './store'
import 'bootstrap'
import './sass/app.scss'

Vue.use(VuePageTransition)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
